import type { Measurement } from "../types";

export const measurementGeometryKey = (measurement: Measurement) =>
  `${measurement.id}:${measurement.type}:${measurement.value}:${measurement.units}:${measurement.northReference}:${measurement.declination}:${measurement.distanceErrorPct ?? 0}:${measurement.bearingErrorDeg ?? 0}:${measurement.lat}:${measurement.lon}`;

export const geometryKeySeedFromMeasurements = (measurements: Measurement[]) =>
  measurements.map((measurement) => measurementGeometryKey(measurement)).join("|");

export const hasSingleDistanceUncertainty = (measurements: Measurement[]) =>
  measurements.length === 1 &&
  measurements[0].type === "distance" &&
  (measurements[0].distanceErrorPct ?? 0) > 0;
